export enum Status {
  DRAFT = 'DRAFT',

  APPROVED = 'APPROVED',

  REJECTED = 'REJECTED',

  RESOLVED = 'RESOLVED',
}
